const roleObj = {
  create: {
    conversations: ['superadmin'],
    images: ['superadmin'],
    vocab: ['superadmin']
  },
  edit: {
    conversations: ['superadmin'],
    images: ['superadmin'],
    vocab: ['superadmin']
  },
  delete: {
    conversations: ['superadmin'],
    images: ['superadmin'],
    vocab: ['superadmin']
  },
  view: {
    conversations: ['superadmin'],
    images: ['superadmin'],
    vocab: ['superadmin']
  }
}

const isAllowed = (role, verb, section, param) => {
  if (param) {
    return roleObj[verb][section][param].indexOf(role) !== -1
  }
  return roleObj[verb][section].indexOf(role) !== -1
}

export {
  roleObj,
  isAllowed
}
